import React, {Component} from 'react'
import PropTypes from 'prop-types'
import copy from 'copy-to-clipboard'
import ClipboardIcon from 'components/icons/Clipboard'
import ClipboardCheckedIcon from 'components/icons/ClipboardChecked'
import './styles.css'

function selectText(element) {
  const doc = document
  let range
  let selection
  if (doc.body.createTextRange) {
    range = document.body.createTextRange()
    range.moveToElementText(element)
    range.select()
  } else if (window.getSelection) {
    selection = window.getSelection()
    range = document.createRange()
    range.selectNodeContents(element)
    selection.removeAllRanges()
    selection.addRange(range)
  }
}

class CopyText extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)
    this.state = {
      copied: false,
    }
  }

  copyToClipboard = () => {
    copy(this.props.text)
    this.highlightText()
    window.clearTimeout(this.copiedTimeout)
    this.setState({
      copied: true,
    }, () => {
      this.copiedTimeout = setTimeout(() => {
        this.setState({
          copied: false,
        })
      }, 3000)
    })
  }

  highlightText = () => {
    if (this.contentNode) {
      selectText(this.contentNode)
    }
  }

  bindContentNode = (node) => {
    this.contentNode = node
  }

  render() {
    const {
      text,
    } = this.props
    const {
      copied,
    } = this.state
    const iconSize = 18
    if (typeof text !== 'string' || text.length === 0) {
      return null
    }

    return (
      <div className="CopyText">
        <div className="copy-text-control">
          <span className="copy-text-content" onClick={this.highlightText} ref={this.bindContentNode}>
            {text}
          </span>
          <button onClick={this.copyToClipboard}>
            {copied ? (
              <ClipboardCheckedIcon
                height={iconSize}
                width={iconSize}
              />
            ) : (
              <ClipboardIcon
                height={iconSize}
                width={iconSize}
              />
            )}
          </button>
        </div>
        <span className={copied ? 'copy-text-copied copy-text-copied-visible' : 'copy-text-copied'}>Copied!</span>
      </div>
    )
  }
}

export default CopyText



// WEBPACK FOOTER //
// ./src/components/_molecules/CopyText/index.js